function initFirebaseProduct() {
  document.addEventListener("DOMContentLoaded", function () {
    // Firebase configuration from Shopify settings
    const firebaseConfig = {
      apiKey: "",
      authDomain: "",
      projectId: "",
      storageBucket: "",
      messagingSenderId: "",
      appId: "",
    };

    // Get product handle from URL
    const pathParts = window.location.pathname.split("/");
    const productHandle = pathParts[pathParts.length - 1];

    function updateProductData() {
      try {
        // Initialize Firebase
        if (!firebase.apps.length) {
          firebase.initializeApp(firebaseConfig);
        }
        const db = firebase.firestore();

        // Query Firebase for the product
        db.collection("products")
          .where("handle", "==", productHandle)
          .get()
          .then((querySnapshot) => {
            if (!querySnapshot.empty) {
              const productData = querySnapshot.docs[0].data();

              // Update all product elements
              document
                .querySelectorAll(".firebase-product-title")
                .forEach((el) => (el.textContent = productData.title || ""));

              document
                .querySelectorAll(".firebase-product-price")
                .forEach(
                  (el) =>
                    (el.textContent = productData.price
                      ? "$" + productData.price
                      : "")
                );

              document
                .querySelectorAll(".firebase-product-description")
                .forEach(
                  (el) => (el.textContent = productData.description || "")
                );

              document
                .querySelectorAll(".firebase-product-image")
                .forEach((el) => {
                  el.src = productData.image_url || "";
                  el.alt = productData.title || "Product Image";
                });

              // Update availability
              document
                .querySelectorAll(".firebase-product-availability")
                .forEach((el) => {
                  if (productData.available) {
                    el.innerHTML = `
                    <form method="post" action="/cart/add" class="product-form">
                      <input type="hidden" name="id" value="${
                        productData.variant_id || ""
                      }">
                      <button type="submit" class="add-to-cart-button">
                        Add to Cart
                      </button>
                    </form>
                  `;
                  } else {
                    el.innerHTML =
                      '<div class="product-unavailable">This product is currently unavailable</div>';
                  }
                });
            } else {
              document
                .querySelectorAll(".firebase-product-container")
                .forEach(
                  (el) =>
                    (el.innerHTML =
                      '<div class="product-unavailable">Product not found</div>')
                );
            }
          })
          .catch((error) => {
            console.error("Error fetching product:", error);
            document
              .querySelectorAll(".firebase-product-container")
              .forEach(
                (el) =>
                  (el.innerHTML =
                    '<div class="product-unavailable">Error loading product data</div>')
              );
          });
      } catch (e) {
        console.warn("Firebase initialization error:", e);
        document
          .querySelectorAll(".firebase-product-container")
          .forEach(
            (el) =>
              (el.innerHTML =
                '<div class="product-unavailable">Error initializing Firebase</div>')
          );
      }
    }

    // Initial update
    if (productHandle) {
      updateProductData();
    }

    // Update every 5 minutes
    // setInterval(updateProductData, 300000);
  });
}

// Initialize on page load
initFirebaseProduct();

// Initialize in theme editor
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    initFirebaseProduct();
  });
}
